import React from 'react'
import { Divider, LayoutBand, Separator, useContainerWidth } from '@fs/zion-ui'
import NavLinks from './NavLinks'
import SocialSection from './SocialSection'

export default function FooterExpansionContent({ nonReligiousMode = true, canSeeTemple, external = false }) {
  const atWidth = useContainerWidth()

  return (
    <>
      <LayoutBand marginX="lg" marginY="lg">
        <NavLinks nonReligiousMode={nonReligiousMode} canSeeTemple={canSeeTemple} external={external} />
      </LayoutBand>
      <Divider fullWidth />
      <LayoutBand marginY="nano" marginX="lg">
        <Separator size={atWidth({ default: 'sm', sm: 'xs' })} />
        <SocialSection external={external} nonReligiousMode={nonReligiousMode} />
      </LayoutBand>
    </>
  )
}
